<div class="page">
   <div class="header">
      <mat-toolbar color="primary">
         <div *ngIf="topbarTemplate$ | async as template" class="text-center w-100">
            <ng-container *ngTemplateOutlet="template"></ng-container>
         </div>
      </mat-toolbar>
   </div>

   <div class="body">
      <router-outlet></router-outlet>
   </div>

   <div class="mat-elevation-z8 z-0">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel">
         <a
            *ngFor="let tab of tabs"
            mat-tab-link
            [routerLink]="tab.link"
            routerLinkActive="active"
            [disableRipple]="true"
         >
            <div class="tab-item">
               <mat-icon>{{ tab.icon }}</mat-icon>
               <span>{{ tab.name }}</span>
            </div>
         </a>
      </nav>

      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
   </div>
</div>
